module.exports = __webpack_public_path__ + "static/media/website-in-progress-desktop.187daf06.svg";